import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import firebase from "./firebase";
import "../Sidebar.css";
import Navigations from "./navbarAdmin";
import { update_user, remove_user, onOpen } from "../store/actions/actions";
import "../screens/Admin/styles.css";
// import './scripts'
class Books extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blogs: [],
      books: [],
      downloads: [],
      showModal: false,
    };
  }

  componentDidMount() {
    console.log("this.props", this.props.changeColor);
    this.authListener();
  }

  blogData = () => {
    this.firebaseRef = firebase.database().ref("BlogData");
    this.firebaseRef.on("value", (snapshot) => {
      let message = snapshot.val();
      // console.log(message)
      var newArr = [];
      for (let word in message) {
        // console.log(message[word].pushKey);
        newArr.push({
          createAt: message[word].createAt,
          newPostKey: message[word].newPostKey,
          heading: message[word].heading,
          description: message[word].description,
          downloadURL: message[word].downloadURL,
        });
      }
      // console.log(message);
      // // arr.push(message)
      this.setState({ blogs: newArr });
    });
  };

  authListener() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // console.log("user changed..", user.email);
        this.setState({
          uid: user.uid,
          displayEmail: user.email,
        });
      } else {
        // No user is signed in.
        // browserHistory.push("/signin");
      }
    });
  }
  openModal = (event) => {
    if (this.state.showModal === false) {
      this.setState({ showModal: true });
    } else if (this.state.showModal === true) {
      this.setState({ showModal: false });
    }
  };
  render() {
 
    return (
      <div >
        <Navigations />
        <div id="layoutSidenav">
          <div id="layoutSidenav_nav">
            <nav
              class={
                this.props.changeColor
                  ? " sb-sidenav accordion sb-sidenav-light"
                  : " sb-sidenav accordion sb-sidenav-dark"
              }
              id="sidenavAccordion"
            >
              <div class="sb-sidenav-menu">
                <div class="nav">
                  {/* <div class="sb-sidenav-menu-heading">Core</div> */}
                  <a class="nav-link" href="/admin">
                    <div class="sb-nav-link-icon">
                      <i class="fas fa-tachometer-alt"></i>
                    </div>
                    Dashboard
                  </a>

                  <a class="nav-link" href="/AddBlogs">
                    <div class="sb-nav-link-icon">
                      <i class="fas fa-chart-area"></i>
                    </div>{" "}
                    Blogs
                  </a>
                  <a class="nav-link" href="/addDownloads">
                    <div class="sb-nav-link-icon">
                      <i class="fas fa-table"></i>
                    </div>{" "}
                    Downloads
                  </a>
                  <a class="nav-link" href="/addbooks">
                    <div class="sb-nav-link-icon">
                      <i class="fas fa-chart-area"></i>
                    </div>{" "}
                    Books
                  </a>
                  <a class="nav-link" href="/projects">
                    <div class="sb-nav-link-icon">
                      <i class="fas fa-table"></i>
                    </div>{" "}
                    Projects
                  </a>
                  <a class="nav-link" href="/videos">
                    <div class="sb-nav-link-icon">
                      <i class="fas fa-table"></i>
                    </div>{" "}
                    Videos
                  </a>
                  <a
                    class={
                      this.state.showModal ? "nav-link " : "nav-link collapsed"
                    }
                    // href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseLayouts"
                    aria-expanded="false"
                    aria-controls="collapseLayouts"
                    onClick={() => this.openModal()}
                  >
                    <div class="sb-nav-link-icon">
                      <i class="fas fa-columns"></i>
                    </div>
                    Clients
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class={this.state.showModal ? "collapse show" : "collapse "}
                    id="collapseLayouts"
                    aria-labelledby="headingOne"
                    data-bs-parent="#sidenavAccordion"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <a class="nav-link" href="/clients-testimonials">
                        Clients Testimonials
                      </a>
                      <a class="nav-link" href="/clients-data">
                        Clients Comments
                      </a>
                    </nav>
                  </div>
                </div>
              </div>
              <div class="sb-sidenav-footer">
                <div class="small">Logged in as:</div>
                {this.state.displayEmail}
              </div>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

// export default Books
const mapStateToProps = (state) => {
  console.log(state);
  return {
    user: state.user,
    changeColor: state.dw,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    store_user: (user) => dispatch(update_user(user)),
    logout_user: () => dispatch(remove_user()),
    onToggle: (user) => dispatch(onOpen(user)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Books));
